var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M816 1802 c-92 -54 -169 -102 -170 -106 -1 -10 334 -206 354 -206 18 0 349 191 352 204 4 10 -331 206 -352 206 -8 0 -91 -44 -184 -98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 1402 l0 -208 178 -102 c97 -56 181 -102 185 -102 4 0 7 94 7 208 l0 208 -178 102 c-97 56 -180 102 -185 102 -4 0 -7 -94 -7 -208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213 1507 l-173 -102 0 -207 c0 -115 3 -208 7 -208 4 0 88 46 185 102 l178 102 0 208 c0 160 -3 208 -12 207 -7 -1 -91 -47 -185 -102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 1298 c-25 -27 -25 -33 -1 -401 l17 -279 166 -161 c161 -156 167 -164 177 -215 6 -29 11 -73 11 -97 l0 -45 200 0 c184 0 200 1 200 18 0 9 -7 125 -15 257 -11 163 -20 246 -29 261 -8 11 -91 93 -184 182 -162 154 -173 162 -211 162 -47 0 -81 -35 -81 -84 0 -26 15 -45 102 -128 87 -82 101 -100 92 -115 -6 -9 -15 -18 -21 -20 -11 -4 -228 198 -243 227 -5 9 -14 97 -20 196 -6 98 -13 189 -16 201 -12 60 -102 86 -144 41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712 1300 c-28 -26 -29 -32 -42 -244 -6 -99 -15 -187 -20 -196 -15 -29 -232 -231 -243 -227 -6 2 -15 11 -21 21 -9 15 4 31 87 109 79 75 99 99 103 127 8 52 -24 90 -77 90 -38 0 -49 -9 -213 -162 -95 -90 -178 -172 -185 -183 -8 -16 -41 -420 -41 -514 0 -21 3 -21 200 -21 l200 0 0 45 c0 24 5 68 11 97 10 51 16 59 176 214 l166 162 20 326 20 326 -23 25 c-30 32 -87 34 -118 5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.252a27a44302ca0a26806ddf9855d6b1.svg";
export { ForwardRef as ReactComponent };